module.exports = __webpack_public_path__ + "static/media/vf-button-women-dress-shoes.bd597602.svg";